import React from 'react';
import PropTypes from 'prop-types';
import { usePagination, useStats } from 'react-instantsearch';

import { useAttendeeMode } from '@context/attendeeModeContext';
import useAttendeePdfs from '@hooks/useAttendeePdfs';
import { BodySmall } from '@styled';

export const SearchAttendeeListLastPage = ({ renderPdfLink }) => {
    const { currentRefinement } = usePagination();
    const { hitsPerPage, nbHits } = useStats();
    const { eventCode } = useAttendeeMode() ?? {};
    const { pdfGroups, loading } = useAttendeePdfs(eventCode);
    const paginationLimit = Number(process.env.ALGOLIA_PAGINATION_LIMIT);
    const totalCount = nbHits > paginationLimit ? paginationLimit : nbHits;
    const rangeEnd = (currentRefinement + 1) * hitsPerPage.hitsPerPage;

    if (loading || !pdfGroups.length || totalCount < paginationLimit || rangeEnd <= paginationLimit) {
        return null;
    }

    return (
        <div className="mt-1rem">
            <BodySmall>
                Your search returned more than 1,000 results. Please use the filters on the left to narrow your
                search. To see a full list of attendees (pdf),{' '}
                {renderPdfLink ? renderPdfLink({ pdfGroups, eventCode }) : null}.
            </BodySmall>
        </div>
    );
};

SearchAttendeeListLastPage.propTypes = {
    renderPdfLink: PropTypes.func,
};
